'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _irisPropTypes = require('@spp/iris-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subtitle = function Subtitle(_ref) {
    var text = _ref.text,
        theme = _ref.theme,
        stylizr = _ref.stylizr;
    return _react2.default.createElement(
        'h2',
        { className: theme.subtitle, 'data-test-tag': '@spp/ui-subtitle' },
        stylizr(text.value, text.markup)
    );
};

Subtitle.propTypes = {
    text: _irisPropTypes.objects.text.isRequired,
    stylizr: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        subtitle: _propTypes2.default.string
    })
};

Subtitle.defaultProps = {
    stylizr: function stylizr(text) {
        return text;
    },
    theme: {}
};

exports.default = Subtitle;
//# sourceMappingURL=Subtitle.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-subtitle/lib/cjs/Subtitle.js
 ** module id = 527
 ** module chunks = 1
 **/